import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { API_URL } from '../../../config/constants';
import Pagination from '../../components/Pagination';
import moment from 'moment-timezone';

function AlertLogs(props) {
    const limit = 20;
    const [page, setPage] = useState(1);
    const [totalRowCount, setTotalRowCount] = useState(0);
    const [logs, setLogs] = useState([])

    async function getAlertLogs(needCount = false) {
        const response = await axios.post(`${API_URL}/monitoring-manage/getAlertLogs`, { needCount, pageNo: page })
        const { success } = response.data
        if (success) {
            const { alertLogs, rowCount } = response.data;
            if (rowCount) setTotalRowCount(rowCount)
            setLogs([...alertLogs])
        }
    }

    function getInit() {
        getAlertLogs(true)
    }

    function getMoreLogs() {
        getAlertLogs()
    }

    useEffect(() => {
        getInit()
    }, [])

    useEffect(() => {
        getMoreLogs()
    }, [page])

    return (
        <div className='alertLogs'>
            <h3>경보 로그</h3>
            <table>
                <thead>
                    <tr>
                        <th className="time">시간</th>
                        <th className='topic'>토픽</th>
                        <th className='message'>메시지</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        logs.map((el, idx) => {
                            return (
                                <tr key={`logs_${el.idNo}`}>
                                    <td>{moment(el.time).tz('Asia/Seoul').format('YYYY-MM-DD HH:mm:ss')}</td>
                                    <td>{el.topic}</td>
                                    <td>{el.message}</td>
                                </tr>
                            )
                        })
                    }
                </tbody>
            </table>
            <Pagination
                total={totalRowCount}
                limit={limit}
                page={page}
                setPage={setPage}
            />
        </div>
    );
}

export default AlertLogs;
